import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import {
  toWidget,
  viewToModelPositionOutsideModelElement
} from '@ckeditor/ckeditor5-widget/src/utils';
import Widget from '@ckeditor/ckeditor5-widget/src/widget';

import InsertImageCommand from './insertimagecommand';
import { CkeditorConstants, removeDefaultHtmlSpanAttributes } from '../../src/utils';

const { htmlAttributes: { ID, ABOUT } } = CkeditorConstants;

export default class InsertImageUI extends Plugin {
  static get requires() {
    return [Widget];
  }

  init() {
    this._defineSchema();
    this._defineConverters();
    this.editor.commands.add('insertimage', new InsertImageCommand(this.editor));
    this.editor.editing.mapper.on(
      'viewToModelPosition',
      viewToModelPositionOutsideModelElement(this.editor.model, viewElement => viewElement.hasClass('inlineimage'))
    );

    this.listenTo(this.editor.editing.view.document, 'click', () => {
      const selectedElement = this.editor.model.document.selection.getSelectedElement();
      if (selectedElement?.name === 'inlineimage') {
        const childNode = selectedElement._children._nodes[0];
        const imgObj = {
          mediaName: 'image',
          'name': childNode._attrs.get("data-node-name"),
          'imageId': childNode._attrs.get("id"),
          'height': childNode._attrs.get("height"),
          'width': childNode._attrs.get("width"),
          'align': '',
          'altText': childNode._attrs.get("alt") || childNode._attrs.get("data-node-name"),
          'imageType': 'inline',
          'dataTenantId': childNode._attrs.get("data-tenant-id")
        }
        this.editor.fire('mediaselected', imgObj);
      }
    });
  }

  _defineSchema() {
    const schema = this.editor.model.schema;
    schema.register('inlineimage', {
      allowWhere: '$text',
      isInline: true,
      isObject: true,
      allowAttributesOf: '$text',
      allowContentOf: '$root',
      allowAttributes: ['class', ID, ABOUT]
    });
  }
  _defineConverters() {
    const conversion = this.editor.conversion;
    this.editor.model.schema.addAttributeCheck(context => {
      if (context.endsWith('inlineimage')) {
        return true;
      }
    });

    conversion.for('upcast').elementToElement({
      view: {
        name: 'span',
        classes: ['ck-span']
      },
      model: (viewElement, { writer: modelWriter }) => {
        const inlineImageTag = modelWriter.createElement('inlineimage', viewElement.getAttributes());
        modelWriter.append([...viewElement.getChildren()], inlineImageTag);
        return inlineImageTag;
      }
    });

    conversion.for('dataDowncast').elementToElement({
      model: 'inlineimage',
      view: (modelItem, { writer: viewWriter }) => {
        removeDefaultHtmlSpanAttributes(modelItem, this.editor);
        const image = viewWriter.createContainerElement('span', { class: 'ck-span', ...Object.fromEntries(modelItem.getAttributes()) });
        return image;
      }
    });

    conversion.for('editingDowncast').elementToElement({
      model: 'inlineimage',
      view: (modelItem, { writer: viewWriter }) => {
        removeDefaultHtmlSpanAttributes(modelItem, this.editor);
        const image = viewWriter.createContainerElement('span', { class: 'ck-span', ...Object.fromEntries(modelItem.getAttributes()) });
        return toWidget(image, viewWriter, { hasSelectionHandle: true });
      }
    });

    conversion.for('downcast')
      .add(dispatcher => {
        dispatcher.on('attribute', (evt, data, conversionApi) => {
          if ((data.item.name == 'img' || data.item.name == 'inlineimage') && (data.attributeKey === 'src' || data.attributeKey === 'resource')) {
            const viewWriter = conversionApi.writer;
            const viewElement = conversionApi.mapper.toViewElement(data.item);
            const originUrl = location.origin + '/alfresco/s/wk/content?tenantId=';
            const alf_ticket = localStorage.getItem('ticket-ECM');
            if (!data.attributeNewValue?.includes('alf_ticket=') && alf_ticket) {
              data.attributeNewValue = data.attributeNewValue + `&alf_ticket=${alf_ticket}`;
              viewWriter.setAttribute(data.attributeKey, data.attributeNewValue, viewElement);
            }

            if (!data.attributeNewValue?.includes(originUrl)) {
              data.attributeNewValue = originUrl + data.attributeNewValue;
              viewWriter.setAttribute(data.attributeKey, data.attributeNewValue, viewElement);
            }
          }
        });
      });
  }
}